module.exports = function () {
    return Promise; // eslint-disable-line
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jpex-defaults/src/$$promise.js
// module id = g7PO
// module chunks = 0